module.exports = __webpack_public_path__ + "img/4F4F4F_A1A1A1_8C8C8C_848484-256px.ecdd58ad.png";